'use strict';

var _ = require('lodash');

function NavDrawerController () {

  var DEFAULTS = {
    open: false,
    opened: false, // set to true once transition has completed
    page: '',
    pageView: '',
    state: '',
  };

  var vm = this;
  _.defaults(vm, DEFAULTS);

  vm._getState = function() {
    return [this.page, this.pageView, this.open];
  }.bind(this);

  vm.setState = function (state) {
    vm.state = state;
  };

  vm.setPageView = function (viewId) {
    vm.pageView = viewId;
  };

}

module.exports = NavDrawerController;


// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/layout/src/nav/NavDrawerController.js